import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const CantidadCompaniasFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='CANTIDAD COMPANIAS' htmlFor='input-cantidadCompanias' md={12} />
      <Col md={12}>
        <Field name='cantidadCompanias'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='input-cantidadCompanias'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CantidadCompaniasFormGroup)
